if (!customElements.get('he-card-siblings')) {
  customElements.define(
    'he-card-siblings',
    class HeCardSiblings extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('[data-he-product-card]');
        if (!this.card) return;

        this.links = this.card.querySelectorAll('[data-he-card-link]');
        this.image = this.card.querySelector('[data-he-card-image]');
        this.price = this.card.querySelector('[data-he-card-price]');
        this.quickAdd = this.card.querySelector('[data-he-quick-add]');
        this.items = this.querySelectorAll('[data-he-sibling]');

        this.defaultState = {
          urls: Array.from(this.links).map((link) => link.getAttribute('href')),
          image: this.image ? this.image.getAttribute('src') : '',
          price: this.price ? this.price.innerHTML : '',
          siblingColor: this.quickAdd ? this.quickAdd.dataset.siblingColor || '' : '',
        };

        this.items.forEach((item) => {
          item.addEventListener('mouseenter', () => this.applySibling(item));
          item.addEventListener('focus', () => this.applySibling(item));
          item.addEventListener('click', () => this.visitSibling(item));
        });

        this.addEventListener('mouseleave', () => this.resetCard());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.resetCard();
        });
      }

      applySibling(item) {
        const url = item.dataset.heSiblingUrl;
        const price = item.dataset.heSiblingPrice;
        const image = item.dataset.heSiblingImage;
        const color = item.dataset.heSiblingColor;

        if (url) {
          this.links.forEach((link) => {
            link.setAttribute('href', url);
          });
        }

        if (price && this.price) {
          this.price.innerHTML = price;
        }

        if (image && this.image) {
          this.image.setAttribute('src', image);
        }

        if (this.quickAdd) {
          if (color) {
            this.quickAdd.dataset.siblingColor = color;
          } else {
            delete this.quickAdd.dataset.siblingColor;
          }
        }
      }

      resetCard() {
        this.links.forEach((link, index) => {
          const url = this.defaultState.urls[index];
          if (url) link.setAttribute('href', url);
        });

        if (this.image && this.defaultState.image) {
          this.image.setAttribute('src', this.defaultState.image);
        }

        if (this.price) {
          this.price.innerHTML = this.defaultState.price;
        }

        if (this.quickAdd) {
          if (this.defaultState.siblingColor) {
            this.quickAdd.dataset.siblingColor = this.defaultState.siblingColor;
          } else {
            delete this.quickAdd.dataset.siblingColor;
          }
        }
      }

      visitSibling(item) {
        const url = item.dataset.heSiblingUrl;
        if (url) window.location.href = url;
      }
    }
  );
}
